// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JOxN","type":"styles_type__231Yz","choices":"styles_choices__1m09t"};